import TrainType from './train-type';

export default TrainType;